<template>
	<div class="dc-header-wrap">
		<i class="dc-header-back-icon" :class="['iconfont', 'icon-fuwuhaoxiaochengxutubiao_fanhui']" @click="goBack"></i>
		<div class="dc-header-title">{{ title }}</div>
		<div v-if="isShare" class="dc-header-share" @click.stop="toggleDropdown">
			<i class="dc-header-share-icon iconfont icon-gongneng_sandiangengduo"></i>
			<div v-if="showDropdown" class="dc-header-dropdown" @click.stop>
				<slot name="dropdown"></slot>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, provide } from 'vue';

const props = defineProps({
	title: {
		type: String,
		default: '确认订单',
	},
	isShare: {
		type: Boolean,
		default: false,
	},
	backMethod: {
		type: Function,
		default: null,
	},
});

const showDropdown = ref(false);
/** 供 #dropdown 内 DropDown 等组件 inject，在菜单跳转前收起顶栏下拉 */
const closeDropdown = () => {
	showDropdown.value = false;
};
provide('closeDcHeaderDropdown', closeDropdown);

const router = useRouter();

const goBack = () => {
	if (props.backMethod) {
		props.backMethod();
	} else {
		router.back();
	}
};

/** 打开菜单的同一轮点击里，document 的 click 可能随后触发，需忽略一次避免立刻关闭 */
const ignoreDocClickOnce = ref(false);

const toggleDropdown = () => {
	const next = !showDropdown.value;
	showDropdown.value = next;
	if (next) {
		ignoreDocClickOnce.value = true;
		setTimeout(() => {
			ignoreDocClickOnce.value = false;
		}, 0);
	}
};

// 点击外部关闭下拉菜单
const handleClickOutside = event => {
	if (ignoreDocClickOnce.value) return;
	if (!event.target.closest('.dc-header-share')) {
		showDropdown.value = false;
	}
};

// 监听全局点击事件
onMounted(() => {
	document.addEventListener('click', handleClickOutside);
});

onUnmounted(() => {
	document.removeEventListener('click', handleClickOutside);
});
</script>

<style scoped lang="scss">
.dc-header-wrap {
	position: relative;
	padding: 0 1rem 0 0.7rem;
	display: flex;
	height: 3.67rem;
	align-items: center;
	background-color: #fff;
	box-sizing: border-box;
}

.dc-header-back-icon {
	position: relative;
	z-index: 2;
	font-size: 1rem;
	color: #86909c;
	cursor: pointer;
	font-weight: bold;
}

.dc-header-title {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	font-family: 'Source Han Sans', '思源黑体', sans-serif;
	font-size: 1.33rem;
	font-weight: 500;
	line-height: 1.83rem;
	color: #333333;
	text-align: center;
	white-space: nowrap;
	max-width: min(60%, calc(100% - 5.75rem));
	overflow: hidden;
	text-overflow: ellipsis;
}

.dc-header-share {
	margin-left: auto;
	position: relative;
	z-index: 2;
	cursor: pointer;
}

.dc-header-share-icon {
	font-size: 1.5rem;
	color: #000000;
}

.dc-header-dropdown {
	position: absolute;
	top: 2rem;
	right: -1rem;
	width: 9.58rem;
	min-height: 2.25rem;
	padding: 0.25rem 0;
	box-sizing: border-box;
	background: #25293c;
	z-index: 9999;
	margin-top: 0.4rem;
	border-radius: 0.42rem;
	box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

	&::before {
		position: absolute;
		right: 1.15rem;
		top: -0.3rem;
		content: '';
		display: block;
		width: 0.94rem;
		height: 0.94rem;
		background-color: #25293c;
		border-radius: 0.25rem;
		transform: rotate(45deg);
	}
}
</style>
